import { useEffect, useState } from "react";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { useNavigate } from "react-router-dom";

const DBACategoryMappings = ({ selectedDba }: any) => {
  const navigate = useNavigate();
  const [columnDefs, setColumnDefs] = useState([]);
  const [dbaTaxonomiesListData, setDBATaxonomiesListData] = useState([]);

  const createColumnDefs = () => {
    setColumnDefs([
      {
        field: 'Sl',
        headerName: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        cellRenderer(params: any) {
          return parseInt(params.node.id, 10) + 1;
        },
      },
      { field: 'DBADomainName', headerName: 'DBA Domain Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'DBACategoryName', headerName: 'DBA Category Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'DBACategoryCode', headerName: 'DBA Category Code', sortable: true, filter: true, filterType: 'text' },
    ]);
  };

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Category Mapping</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleAdd = () => {
    navigate(`/management/dbn-cloud/dbn-taxonomy/dbn-categories/${0}`)
  }

  const handleEditDBNCategory = (data: any) => {
    navigate(`/management/dbn-cloud/dbn-taxonomy/dbn-categories/${data?.DBACategoryCode}`)
  }

  const handleReloadData = () => {
    dbaTaxonomiesDataList();
  }

  const dbaTaxonomiesDataList = () => {
    const resultData: any[] = [];

    selectedDba?.DBATaxonomies?.forEach((domain: any) => {
      if (domain?.DBACategories?.length) {
        domain?.DBACategories.forEach((category: any) => {
          resultData.push({
            DBADomainName: domain?.DBADomainName,
            DBACategoryName: category?.DBACategoryName || '-',
            DBACategoryCode: category?.DBACategoryCode || '-',
          });
        });
      } else {
        resultData.push({
          DBADomainName: domain?.DBADomainName,
          DBACategoryName: '-',
          DBACategoryCode: '-',
        });
      }
    });

    setDBATaxonomiesListData(resultData);
  };

  useEffect(() => {
    createColumnDefs();
    dbaTaxonomiesDataList();
  }, [selectedDba]);

  return (
    <>
      {selectedDba?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={dbaTaxonomiesListData}
          enableFilter={true}
          additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'DBACategoryCode',
          }}
          headingName="DBA Category Mappings"
        />
      }
    </>
  );
};

export default DBACategoryMappings;